module.exports = __webpack_public_path__ + "static/media/covi_wor_met.887ffa3e.png";